/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: any } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const role = currentUser?.role;
  // 调试：打印当前用户角色与权限判断结果
  // eslint-disable-next-line no-console
  //console.log('access - currentUser:', currentUser);
  // eslint-disable-next-line no-console
  //console.log('access - currentUser.role:', role);
  // eslint-disable-next-line no-console
  //console.log('access - canAdmin (role === \"admin\"):', role === 'admin');
  return {
    // 兼容路由中的 access: 'canAdmin'（admin 与 observer 均可见 Admin 菜单）
    canAdmin: role === 'admin' || role === 'observer',
    isAdmin: role === 'admin',
    isObserver: role === 'observer',
    // canEditAdmin 为 true 时表示能在管理员界面进行写操作（admin），observer 会看到界面但不能编辑
    canEditAdmin: role === 'admin',
    canEditProviders: role === 'admin' || role === 'observer',
  };
}
